function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import { render as reactRender, unmount as reactUnmount } from 'rc-util/lib/React/render';
import React from 'react';
import OriginLoading from "./Loading";
export default function confirm(config) {
  function getContainer(config) {
    var className = config.className;
    var classes = classNames('iron-loading-layout', className);
    var el = document.getElementById('iron-loading-layout');
    if (el === null) {
      el = document.createElement('div');
      document.body.append(el);
      el.id = 'iron-loading-layout';
      el.className = classes; //el.classList.add('iron-loading-layout');
    }
    return el;
  }
  var container = getContainer(config);
  var currentConfig = _objectSpread({}, config);
  function render(props) {
    reactRender( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-mask"
    }), /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-content"
    }, /*#__PURE__*/React.createElement(OriginLoading, props))), container);
  }
  if (currentConfig !== null && currentConfig !== void 0 && currentConfig.showLoading) {
    return render(currentConfig);
  } else {
    reactUnmount(container);
    container.remove();
  }
}